import { MinorHeader } from "../../specific_components/minor_header/minor_header"

import { Badge, Button, Card, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, ImageList, ImageListItem, ImageListItemBar, ListSubheader, Pagination, Stack, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { get_all_packages_list, get_package_detail_view } from "../../../actions/packages_actions"
import { send_email_emailJs } from "../../../actions/shared_actions"
import './packages.css'

import { FilterListOutlined, KeyboardDoubleArrowDownOutlined, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, KeyboardDoubleArrowUpOutlined, MessageSharp, RefreshOutlined, SearchOutlined } from "@mui/icons-material"
import { Helmet } from 'react-helmet'
import { Route, Routes, useNavigate, useParams } from "react-router-dom"
import { post_short_alert_message } from "../../../actions/error_actions"
import { PACKAGES_ROUTE } from "../../../routing/routing_constants"
import { LoadingSpinner } from "../../sharable_components/small_components/alerts/loading"
import { packageCategories } from "./constants"
import { FadeInSection, MediaComponent } from "./home_window"
import { PackCategoryCard } from "./packs_page"

export const Packages = () => {
	
	return (
		<div style={{width:'100%'}}>
			 <div className="landing_images_2 landing_center" id="site_cover_image">
                <Helmet>
                    <title>DGA | Packages</title>
                </Helmet>
                <div className="company_details">
                    <div className="company_name smaller_company_name" id="company_name">
                        TRAVEL PACKAGES
                    </div>
                    <div className="tag_line">
                        EXPLORE THE WORLD
                    </div>
                </div>
                <div className="navigation_on_home_container">
                </div> 
            </div>
			<div className="packages_main middle_component" style={{marginTop:'0px'}}>
				{/* <div className="packs_window"> */}
					<Routes>
						<Route path="" element={<AllPackages />} />
						<Route path=":id" element={<DetailViewDialog />} />
					</Routes>
				{/* </div> */}
			</div>
		</div>
	)
}


export const AllPackages = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const orig_params = {
		tags:[],
		location:[],
		duration:[]
	}
	const [search_params, setSearchParams] = useState(orig_params)

	const [lists, setLists] = useState({})
	const [load, set_load] = useState(false)
	const [more_categories, set_show_more] = useState(false)
	const [open_filter, set_open_filter] = useState(false)
	const [open_search, set_open_search] = useState(false)

	//   pagination
	const [page, setPage] = useState(1)
	const handleChangePage = (event, value) => {
		window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})
		setPage(value);
	};

	const pages_total = Math.ceil(lists?.count/lists?.results?.length)

	const get_all_packages = (page, search='', filter='', other_filters=false, tags=[], location=[], duration=[]) =>{
		setLists({})
		set_load(true)
		get_all_packages_list(page, search, filter, other_filters, tags, location, duration)
			.then(res=>{
				set_load(false)
				setLists(res)
				window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})
			})
			.catch(()=>set_load(false))
	}

	useEffect(()=>{
		get_all_packages(page)
	}, [page])


	const handleFilter = (e) => {
		e.preventDefault()
		set_open_search(true)
		get_all_packages(1, '', '', true, search_params.tags, search_params.location, search_params.duration)
	}

	const handleSearch = (e, value) => {
		e.preventDefault()
		get_all_packages(page, value)
	}
			
	const handleCategoryFilter = (tag) => {
		set_open_search(true)
		get_all_packages(page, '', tag)

	}

	// open dialog box
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState({"title":""})

  const handleClickOpen = (e, pack) => {
	e.preventDefault()
	setSelected(pack)
	setOpen(true);
  };

  const handleClose = () => {
	setOpen(false);
  };

  const handleSubmitInquiry = (e, inquiry) => {
	inquiry = {...inquiry, message:inquiry.message + `; PACKAGE: ${selected.title}; ID: ${selected.id}`}
	e.preventDefault()
	dispatch(send_email_emailJs(inquiry))
	setOpen(false)
  }


	return (
		<div style={{width:'100%', display:'grid', gridTemplateColumns:'1fr'}} className=''> 
			<div className={`centered_div paper ${'packs_with_head'}`}>
				{/* {show_filter_bar && */}
				<div className={`minor_header_packs hide_in_mini`}>
					<MinorHeader 
						search_params={search_params} 
						set_params={setSearchParams}
						handleFilter={handleFilter}
						pass_action_to_close={()=>null} 

						/>
				</div>
					{/* } */}
				<div>
					<div className="" >
						{/* <Typography variant="h6">Assorted...</Typography> */}
						{/* packCounts?.filter(ct=>ct.tag===c.tag)[0]?.count || */}
						<Grid className={"mainContainer"} container alignItems="stretch" spacing={0.5}>
							{packageCategories.map(c =>
								<Grid item xs={6} sm={6} lg={4} key={c.id}>
									<FadeInSection>
										<PackCategoryCard clickFilter={()=>handleCategoryFilter(c.tag)} category={c} count={ 0} />
									</FadeInSection>
								</Grid>
							).slice(0, !more_categories?2:packageCategories.length)}
						</Grid>
						<IconButton onClick={e=>set_show_more(!more_categories)} >{!more_categories? <KeyboardDoubleArrowDownOutlined />:<KeyboardDoubleArrowUpOutlined />}</IconButton>
					</div>
					<div id="packages" style={{width:'100%', minHeight:'max-content', display:'flex', flexDirection:'column', paddingBottom:'3em', textAlign:'left'}}>
						<Card class='wider_end_services flexrow'>       
							<div><Badge color="info" badgeContent={lists?.count}>{open_search? "Search..": 'All Packages'}</Badge></div>
							<div className="flexrow">
								{/* <IconButton onClick={()=>set_open_search(true)}><Search /></IconButton> */}
								<div className="flexrow" style={{scale:'0.8'}}>
									{open_search && 
									<div className="flexrow"   >
									<input id="search_box" size='small' color="" variant='standard' placeholder='Search...' />
								</div>
									}
									<Button variant={open_search? 'outlined':'text'} type='submit' color={open_search? "inherit":"inherit"} onClick={e=>{
										e.preventDefault()
										if (document.getElementById('search_box')?.value?.length > 2){
											handleSearch(e, document.getElementById('search_box').value)
										} else{
											set_open_search(!open_search)
										}
									}}><SearchOutlined /></Button>
								</div>
								<div className="show_in_mini" >
									<IconButton color="inherit" size="small" onClick={e=>{
										if (!open_search) set_open_filter(!open_filter)
										else {
											set_open_search(false)
											get_all_packages(1)
											setSearchParams(orig_params)
										}
									}
										}> {!open_search? <FilterListOutlined /> :<RefreshOutlined />}</IconButton>
								</div>
								{open_search &&
								<div className="hide in mini" >
									<IconButton color="inherit" size="small" onClick={e=>{
											set_open_search(false)
											get_all_packages(1)
									}
										}>  <RefreshOutlined /></IconButton>
								</div>}
							</div>
						</Card>
						<div className="paper" style={{marginTop:''}}>
						<MediaComponent
                                         loading={load} 
                                         data={lists?.results} 
                                         handleClose={handleClose} 
                                         open={open} pack={selected} 
                                         handleSubmit={handleSubmitInquiry} 
                                         />
							{/* {(lists?.count===0 && !load)? <Typography >Oops😞... No Matching Results</Typography> : 
							<Grid className={"mainContainer"} container alignItems="stretch" spacing={3}>
								{lists?.results?.map((pack)=>(
								<Grid item key={pack.id} xs={12} sm={6} lg={4}>
									<FadeInSection>
										<PackageList pack={pack} enquire={(e)=>handleClickOpen(e, pack)} handleOpenDetail={e=>navigate(`${pack.id}`)}/>
									</FadeInSection>
								</Grid>
								))}
							</Grid>} */}
							{pages_total>0 &&
								<Stack marginTop={"1rem"} spacing={2}>
									<Pagination count={pages_total} page={page} variant="outlined" shape="rounded" onChange={handleChangePage} />
								</Stack>
							}
							{/* <EnquireDialog handleClose={handleClose} open={open} pack={selected} handleSubmit={handleSubmitInquiry} /> */}
							<div className="show_in_mini">
								<FloatingFilter 
									open_filter={open_filter} 
									set_open_filter={set_open_filter}  
									handleSearch={handleSearch} 
									search_params={search_params} 
									set_params={setSearchParams}
									handleFilter={handleFilter}
									/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}


export const FloatingFilter = (props) => {

	const pass_action_to_close = () => {
		props.set_open_filter(false)
	}

	return (
		<Dialog open={props.open_filter} onClose={e=>props.set_open_filter(false)}>
			<MinorHeader 
				handleSearch={props.handleSearch} 
				setSearchValue={props.setSearchValue} 
				search_params={props.search_params} 
				set_params={props.set_params}
				pass_action_to_close={pass_action_to_close} 
				handleFilter={props.handleFilter}
				/>
		</Dialog>
	)
}

export function EnquireDialog({handleClose, open, pack , handleSubmit}) {
	const [en_data, setEn_data] = useState({
		package_id:pack.id,
		package_title:pack.title,
		sys_user_email:"",
		message_category:"Query",
		message:""
	})
  
  return (
	<div>
	  <Dialog open={open} onClose={handleClose}>
		<form onSubmit={(e)=>{
			handleSubmit(e, en_data)
			setEn_data({...en_data, message:"", sys_user_email:"", message_category:"Query"})
			}}>
		<DialogTitle>Enquire</DialogTitle>
		<DialogContent>
			<CardMedia className={"media"} image={pack.cover_image} title={pack.title}/>
		  <DialogContentText>
			What would you like to enquire about {pack.title}?
		  </DialogContentText>

		  <TextField
			id="inquiry"
			label="Inquiry"
			fullWidth
			value={en_data.message}
			variant="outlined"
			multiline={true}
			rows={2}
			onChange={(e)=>setEn_data({...en_data, message:e.target.value})}
			required
		  />
		  <DialogContentText>
			How can we reach back to you?
		  </DialogContentText>
		  <TextField
			margin="normal"
			id="contact"
			label="Email Address or Phone Number"
			fullWidth
			variant="outlined"
			value={en_data.sys_user_email}
			onChange={e=>setEn_data({...en_data, sys_user_email:e.target.value})}
			required
		  />
		</DialogContent>
		<DialogActions>
		  <Button onClick={e=>{
			setEn_data({...en_data, message:"", sys_user_email:"", message_category:"Query"})
			e.preventDefault()
			handleClose()
			}}>Cancel</Button>
		  <Button color="warning" type="submit">Submit</Button>
		</DialogActions>
		</form>
	  </Dialog>
	</div>
  );
}


export function DetailViewDialog({handleSubmitInquiry}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [package_detail, setPackageDetail] = useState({})
  const [load, set_load] = useState(false)
  const { id } = useParams()

  useEffect(() => {
	set_load(true)
		get_package_detail_view(id)
			.then(res=>setPackageDetail(res))
			.catch(e=>{
				dispatch(post_short_alert_message({error:e.message}))
			})
			.finally(()=>set_load(false))
  }, [ dispatch, id]);


  return (
	<div>
		<Helmet>
            <title>DGA | Pack </title>
			<meta 
				name={`${package_detail?.title}`}
				desciption={`${package_detail?.description}`}
			/>
        </Helmet>
	  <div className="paper">
	  	<DialogActions>
		  <Button size="small" variant="outlined" onClick={()=>window.history.back()}  ><KeyboardDoubleArrowLeft />BACK </Button>
		  <Button size='small' color="warning" variant="outlined" onClick={e=>navigate(PACKAGES_ROUTE)}>ALL PACKAGES <KeyboardDoubleArrowRight /></Button>
		</DialogActions>
		<DialogTitle id="scroll-dialog-title">{package_detail?.title}</DialogTitle>
		
		{load? <div style={{minHeight:"300px"}} ><LoadingSpinner style={{backgroundColor:"transparent"}} message={""} /> </div>: <div>
		<DialogContent dividers={true}>
		  <CardMedia component={'img'} className="media_clear" loading="lazy" alt="" image={package_detail?.cover_image} />
		  <DialogContentText
			id="scroll-dialog-description"
			tabIndex={-1}
		  >
			<CardContent>{package_detail?.description}</CardContent>
			
			<div>
			  <h3>Price Ranges</h3>
			  {package_detail?.cost?.map(p=>
			  <div>
				From
			  	<li>{p.amount} {p.currency} {p.type}</li>
				</div>
				)}
			</div>
			<div>
			  <h3>Price Includes</h3>
			  {package_detail?.requirements?.split('>>').map(r=>
				<Typography variant=""><li>{r}</li></Typography>
				)}
			</div>
		  </DialogContentText>
		  <h3> Sights</h3>
		  <ImageList sx={{ width: '100%', height: 450 }} variant="quilted">
			<ImageListItem key="Subheader" cols={2}>
				<ListSubheader component="div">Possible sights</ListSubheader>
			</ImageListItem>
			{package_detail.images?.map((item) => (
				<ImageListItem key={item.image} cols={2}>
				<img
					src={`${item.image}?w=248&fit=crop&auto=format`}
					srcSet={`${item.image}`}
					alt={item.description}
					loading="lazy"
				/>
				<ImageListItemBar
					title={item.description}
				/>
				</ImageListItem>
			))}
    		</ImageList>

		<div style={{marginTop:'40px'}}>
			<Typography variant="subtitle2">Tags</Typography>
			<div className="flexrrow">
				{package_detail?.categories?.map(t => <Typography className="typography header_tag margin" style={{margin:"4px", color:"white"}} variant="caption">{t.tag} </Typography>)}
			</div>
		</div>
		</DialogContent>
		<DialogActions>
		  <Button onClick={handleSubmitInquiry}><MessageSharp style={{fontSize:'15px'}} />Enquire</Button>
		</DialogActions>
		</div>
			}		
	  </div>
	</div>
  );
}



